var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCaretSlim = function SvgCaretSlim(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 9 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0E2CC9",
    fillRule: "evenodd",
    d: "M.311 14.847a.777.777 0 0 1 0-1.112L6.146 8 .31 2.265a.777.777 0 0 1 0-1.112.81.81 0 0 1 1.132 0l6.4 6.291a.777.777 0 0 1 0 1.112l-6.4 6.29a.81.81 0 0 1-1.132 0",
    clipRule: "evenodd"
  })));
};
export default SvgCaretSlim;